import { apiClient } from './api';

export interface CampaignStore {
  id: string;
  code?: string;
  name: string;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  distanceKm?: number | null;
  isAvailable?: boolean;
}

export interface DisabledDate {
  date: string;
  reason: string;
}

export interface CampaignStoreAvailability {
  campaignId: string;
  storeId: string;
  availableDates: string[];
  disabledDates: DisabledDate[];
}

export const campaignService = {
  async getStores(
    campaignId: string,
    location?: { city?: string; state?: string },
    search?: string,
    coords?: { lat: number; lng: number },
  ): Promise<CampaignStore[]> {
    const params: Record<string, string | number | undefined> = {
      ...location,
      search: search?.trim() || undefined,
    };

    // If coordinates are provided, use proximity mode
    if (coords) {
      params.lat = coords.lat;
      params.lng = coords.lng;
      params.limit = 10;
      delete params.city;
      delete params.state;
    }

    const { data } = await apiClient.get<CampaignStore[]>(`/customer/campaigns/${campaignId}/stores`, {
      params,
    });
    return data || [];
  },

  async getStoreAvailability(campaignId: string, storeId: string): Promise<CampaignStoreAvailability> {
    const { data } = await apiClient.get<CampaignStoreAvailability>(
      `/customer/campaigns/${campaignId}/stores/${storeId}/availability`,
    );
    return data;
  },
};
